import { render, staticRenderFns } from "./AtomLogo.vue?vue&type=template&id=58a51ca2&"
import script from "./AtomLogo.vue?vue&type=script&lang=ts&"
export * from "./AtomLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports